import React from "react";
import { Route, RouteProps } from "react-router-dom";

export const PublicRoute = ({ children, ...rest }: RouteProps) => {
    return <Route {...rest}>{children}</Route>;
};
